module.exports = __webpack_public_path__ + "img/flow.762ee531.png";